import React from 'react';
import './EndCta.css';
import { Link } from 'react-router-dom';

export const EndCta = () => {
	return (
		<section className='end-cta'>
			<div className='end-cta-container'>
				<h2 className='end-cta-title'>Bereit loszulegen?</h2>
				<p className='end-cta-subtext'>
					Starte jetzt kostenlos als Beta-Tester und sichere dir exklusiven lebenslangen
					Premium-Zugang.
				</p>
				<div className='end-cta-buttons'>
					<Link to='beta-signup' className='cta-button end-cta-button'>
						Jetzt Beta-Zugang sichern
					</Link>
					<Link to='/concept' className='cta-button end-cta-button secondary'>
						So funktioniert Erledix
					</Link>
				</div>
			</div>
		</section>
	);
};
